import {
  Center,
  Heading,
  Table,
  TableContainer,
  Tbody,
  Th,
  Thead,
  Tr,
  Td,
} from "@chakra-ui/react";
import ErrorText from "components/API/ErrorText";
import BoxShadowContainer from "components/UIComponents/BoxShadowContainer";
import LoaderSpinner from "components/UIComponents/LoaderSpinner";
import { RequestMethod, RequestName } from "hooks/api/apiHookTypes";
import useApiRequest from "hooks/api/useApiHook";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

const ProfilePurchaseHistory = () => {
  const apiKey = useSelector((state: RootState) => state.apiKey.apiKey);

  const { data, loading, error } = useApiRequest({
    apiToken: apiKey,
    method: RequestMethod.GET,
    name: RequestName.GET_PURCHASES,
  });

  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const options: Intl.DateTimeFormatOptions = {
      day: "numeric",
      month: "short",
      year: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  }

  return data && data.status === 'success' && data.data.purchases ? (
    <BoxShadowContainer className="purchase-history-container">
      <Heading as="h1" size="lg">
        Purchase history
      </Heading>
      <TableContainer mt={3} maxHeight="400px" overflowY="auto">
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Purchase id</Th>
              <Th>Product</Th>
              <Th>Withdraw</Th>
              <Th>Purchase date</Th>
            </Tr>
          </Thead>
          <Tbody>
            {data.data.purchases.map((purchase) => (
              <Tr key={purchase.deal_id}>
                <Td>{purchase.deal_id}</Td>
                <Td>{purchase.product_name_en}</Td>
                <Td>{purchase.amount_usd} $</Td>
                <Td>{formatDate(purchase.date)}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </BoxShadowContainer>
  ) : loading ? (
    <Center>
      <LoaderSpinner />
    </Center>
  ) : (
    error && <ErrorText />
  );
};

export default ProfilePurchaseHistory;
